import { graphql } from '@/generated/gql';

export const DEMAND_CASES_QUERY = graphql(/* GraphQL */ `
  query DemandCases($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        status
        competitiveBiddingRule {
          id
          variant
          isEditable
          isMaskedBidding
        }
        negotiationCases {
          nodes {
            id
            isNegotiationEnabled
            isSupplierUploadAllowed
            isMaskedBidding
            sequenceNumber
            variant
            createdAt
            updatedAt
            sourceReferences {
              id
              sourceReference
              url
            }
            options {
              id
              initiatedBy
              supplierInteractionMode
              negotiationMode
              quoteMode
              negotiationObjective
            }
            supplier {
              id
              internalId
              name
              location {
                id
                internalId
                address
                city
                countryCode
                postalCode
              }
              contact {
                id
                internalId
                email
                firstName
                lastName
                language
                phone
                mobile
              }
            }
            quote {
              ... on TsrctQuoteInterface {
                id
                createdAt
                totalValue
                shipmentTerms {
                  earlyDeliveryAt
                  lateDeliveryAt
                }
                currency
                lineItems {
                  totalValue
                  description
                  id
                  position
                  pricePerUnit
                  quantity
                  shipmentTerms {
                    earlyDeliveryAt
                    lateDeliveryAt
                  }
                  title
                  unitId
                }
                paymentTerms {
                  daysToPayment
                  discount
                }
                hasSupplierComment
              }

              ... on TsrctNegotiatedQuoteInterface {
                totalDiscountedValue
                discount
                totalPriceDiscount
                lineItems {
                  discount
                  discountedPricePerUnit
                  totalDiscountedValue
                }
              }
            }
            status
            processStatus
            isReleasable
            processSteps {
              variant
              status
            }
            lowerDiscountBoundary
            upperDiscountBoundary
            issueSummary {
              totalCount
              openCount
              resolvedCount
            }
            latestComment {
              id
              message
              authorId
              createdAt
              parent {
                id
                variant
              }
            }
          }
          totalCount
        }
      }
    }
  }
`);
